<template>
<div class="edit-profile">
    <div class="container">
        <validation-observer ref="formObserver">
            <div v-if="sendcompleted">
                <h1 class="title send-title">We gaan nu je gegevens doorsturen naar de isolatiebedrijven. Eén van hun zal contact met je opnemen.<br/><br/>Word je dan ook uitgenodigd voor de introductiecursus dan maak je kans op één van de prijzen!</h1>
            </div>
            <div v-else style="display: block;">
                <h2 class="title">Bedankt voor het deelnemen! <br/><br/>Wil je je aanmelding insturen en kansmaken op de prijzen? Vul dan de volgende gegevens in.</h2>
                <form class="profileForm" ref="profileForm" method="POST" v-on:submit.prevent="processForm(form)">
                    <div class="name-wrapper">
                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Voornaam</label>
                        <input name="Voornaam" type="text" v-model="form.profile.firstName" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>

                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Achternaam</label>
                        <input name="Achternaam" type="text" v-model="form.profile.lastName" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>

                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Geboortedatum</label>
                        <Datepicker :language="nl" name="Geboortedatum" v-model="form.profile.dateOfBirth"></Datepicker>
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    
                    <div class="street-wrapper">
                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Straat</label>
                        <input name="Straat" type="text" v-model="form.profile.streetName" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    
                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Huisnummer</label>
                        <input name="Huisnummer" type="text" v-model="form.profile.streetNumber" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    
                    <div class="place-wrapper">
                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Postcode</label>
                        <input name="Postcode" type="text" v-model="form.profile.postcode" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    
                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Plaats</label>
                        <input name="Plaats" type="text" v-model="form.profile.city" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    
                    <div class="education-wrapper">
                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Welke opleiding volg je of heb je net gevolgd</label>
                        <input name="Opleiding" type="text" v-model="form.education.name" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>

                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Naam school</label>
                        <input name="Naam school" type="text" v-model="form.education.organization" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>

                    <validation-provider class="validation-provider" rules="required" v-slot="{ errors }">
                        <label>Plaats school</label>
                        <input name="Plaats school" type="text" v-model="form.education.location" />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    <validation-provider class="validation-provider">
                        <div class="checkbox">
                            <label class="button">
                                <input name="SMS" type="checkbox" v-model="form.notification.sms" />We hebben je email al. Wil je ook een sms ontvangen?
                            </label>
                        </div>
                    </validation-provider>

                    <validation-provider v-if="form.notification.sms" class="validation-provider" rules="required" v-slot="{ errors }">
                        <div>
                            <label>Telefoonnummer</label>
                            <input name="Telefoonnummer" type="text" v-model="form.profile.phone" />
                        </div>
                        <span class="validation-error">{{ errors[0] }}</span>
                    </validation-provider>
                    <span v-if="displayError" class="error-message">Er is een fout opgetreden bij het versturen.</span>
                    <span class="send-button" @click.prevent="processForm">verstuur ></span>
                </form>
            </div>
        </validation-observer>
    </div>
</div>
</template>

<script>
import be from '../services/Backend';

import Datepicker from 'vuejs-datepicker';

export default {
    'components': {
        Datepicker,
    },
    'data': function() {
        return {
            'displayError': false,
            'sendcompleted': false,
            'form': {
                'profile': {
                    "bsn": null,
                    "initials": null,
                    "firstName": null,
                    "lastName": null,
                    "lastNamePrefix": null,
                    "dateOfBirth": null,
                    "gender": "Unknown",
                    "email": null,
                    "phone": null,
                    "streetName": null,
                    "streetNumber": null,
                    "postcode": null,
                    "city": null
                },
                'education': {
                    //"id": null,
                    "name": null,
                    "level": "none",
                    "organization": null,
                    "location": null,
                    "startDate": "2010-01-01T00:00:00.000Z",
                    "endDate": null,
                    "graduated": null
                },
                'notification': {
                    "sms": false,
                } 
            }
        };
    },
    'methods': {
        'processForm': function() {

            this.$refs.formObserver.validate().then(success => {
                this.displayError = false;
                if(!success) {
                    return;
                }

                be.putProfile(this.form.profile)
                    .then(() => {                        
                        return be.postOrPutEducation(this.form.education);        
                    })                    
                    .then(() => {
                        return be.putNotification(this.form.notification);
                    })
                    .then(() => {  
                        return be.postApplication();
                    })
                    .done(() => {                                
                        this.sendcompleted = true;
                    })
                    .catch((e) => {
                        console.log(e);
                        this.displayError = true;
                    });
            });
        },
    },
    mounted() {        
        
        be.getProfile().done((profile) => {
            
            this.form.profile = profile;
            this.sendcompleted = this.$store.state.hasAccessToCourse == 1;

            return be.getEducations()
                .then((educations) => {
                    if (educations.length > 0) {
                        this.form.education = educations[0];
                    }

                    return be.getNotification();
                })
                .then((notification) => {
                    this.form.notification = notification;
                });
        });     
    }
}
</script>